import React from 'react'
import PropTypes from 'prop-types'
import { Row, Col } from 'components/patterns/Layout'
import InputtingDataFrom from 'components/feature/NavigatorPanes/InputtingDataFrom'

import {
  InputOperatorEditor,
  InputValueEditor,
  HysteresisEditor,
  EdgeEditor,
} from '../base'

const TimerEditor = ({ uri, isLogicSet, inputUri }) => (
  <>
    <Row className="form-field vertical">
      <Col className="editor-column" span={24}>
        <InputOperatorEditor uri={uri} />
        <InputValueEditor isTimer uri={uri} />
      </Col>
    </Row>
    {isLogicSet && (
      <>
        <HysteresisEditor uri={uri} />

        <EdgeEditor uri={uri} />
      </>
    )}
    <InputtingDataFrom refQueryUri={inputUri} />
  </>
)

TimerEditor.propTypes = {
  uri: PropTypes.string,
  isLogicSet: PropTypes.bool,
  inputUri: PropTypes.string,
}

export default TimerEditor
